// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__formFooter__Hwzp0 {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 20px;
  margin-right: 30px;
}
.index-module__form__IGi_P {
  padding: 0 2rem;
}
.index-module__section-header__NMuR9 {
  font-weight: bolder;
}
.index-module__slot-availability-header-span__TK5pw {
  font-size: 12px;
  font-weight: lighter;
  margin-left: 0.5rem;
}
.index-module__raise-abr-header-span__osnKn {
  font-size: 12px;
  font-weight: lighter;
  margin-left: 0.5rem;
}
.index-module__raise-abr-container__sZB1O {
  margin: 2rem;
}
.index-module__raise-abr-verify-number-div__vL9r3 {
  display: flex;
  align-items: center;
}
.index-module__raise-abr-verify-btn__qAzC4 {
  margin-left: 10px;
}
.index-module__col-text-align__NN0oX {
  text-align: right;
}
.index-module__margin-btm-12__u7jVf {
  margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdvanceBookingRequest/PayAndParkModal/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".formFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 30px;\n  margin-top: 20px;\n  margin-right: 30px;\n}\n.form {\n  padding: 0 2rem;\n}\n.section-header {\n  font-weight: bolder;\n}\n.slot-availability-header-span {\n  font-size: 12px;\n  font-weight: lighter;\n  margin-left: 0.5rem;\n}\n.raise-abr-header-span {\n  font-size: 12px;\n  font-weight: lighter;\n  margin-left: 0.5rem;\n}\n.raise-abr-container {\n  margin: 2rem;\n}\n.raise-abr-verify-number-div {\n  display: flex;\n  align-items: center;\n}\n.raise-abr-verify-btn {\n  margin-left: 10px;\n}\n.col-text-align {\n  text-align: right;\n}\n.margin-btm-12 {\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formFooter": `index-module__formFooter__Hwzp0`,
	"form": `index-module__form__IGi_P`,
	"section-header": `index-module__section-header__NMuR9`,
	"slot-availability-header-span": `index-module__slot-availability-header-span__TK5pw`,
	"raise-abr-header-span": `index-module__raise-abr-header-span__osnKn`,
	"raise-abr-container": `index-module__raise-abr-container__sZB1O`,
	"raise-abr-verify-number-div": `index-module__raise-abr-verify-number-div__vL9r3`,
	"raise-abr-verify-btn": `index-module__raise-abr-verify-btn__qAzC4`,
	"col-text-align": `index-module__col-text-align__NN0oX`,
	"margin-btm-12": `index-module__margin-btm-12__u7jVf`
};
export default ___CSS_LOADER_EXPORT___;
